import type { CollaboratorAccrualsRepositoryT } from "../../domain/ports/collaboratorAccruals.repository";

type GetCollaboratorAccrualsParamsT = {
  collaboratorId: string;
  colaboraInstanceId: string;
  collaboratorAccrualsRepository: CollaboratorAccrualsRepositoryT;
};

export const getCollaboratorAccruals = async ({
  collaboratorId,
  colaboraInstanceId,
  collaboratorAccrualsRepository,
}: GetCollaboratorAccrualsParamsT) =>
  collaboratorAccrualsRepository.getAll({ collaboratorId, colaboraInstanceId });
